<template>
  <div class="fill-input css-border">
    <b v-if="dataSource.code">{{ dataSource.code }} </b>
    <div class="fill-input__img" v-if="dataSource.content">
      <img
        :src="`${urlQuestionImg}/${dataSource.content}`"
        :alt="dataSource.content"
      />
    </div>
    <!-- Tự điều chỉnh độ rộng input 
      ModifiedBy: anhdd (11/1/2023)
    -->
    <label class="form-control label-answer" v-if="parent.isWorked !== null">
      {{ dataSource.answerContent }}
    </label>

    <input
        v-else
        class="form-control input-hide-place"
        type="text"
        :id="`fill_img_${dataSource.questionId}_${location}`"
        :value="dataSource.answerContent"
        :ref="`fill_img_${dataSource.questionId}_${location}`"
        @blur="
          changeAnswer($event, {
            location,
            type: parent.type,
            questionId: dataSource.questionId,
          })
        "
        @focus="
          handleFocus($event, {
            location,
            type: parent.type,
            questionId: dataSource.questionId,
          })
        "
        @change="
          changeAnswer($event, {
            location,
            type: parent.type,
            questionId: dataSource.questionId,
          })
        "
        @keyup="
          handleFocus($event, {
            location,
            type: parent.type,
            questionId: dataSource.questionId,
          })
        "
        @mouseup="handleMouseSelection($event)"
        placeholder="?"
        autocomplete="off"
        :class="{ 'evt-none': parent.isWorked !== null }"
        onInput="this.parentNode.dataset.value = this.value"
        size="1"
      />
    <!-- ============================== -->

    <!-- :disabled="parent.isTrue !== null" -->

    <!-- :readonly="parent.isTrue !== null" -->
    <!-- :class="{'bg--white': setCheckExcercise.isCheck}" 
			:disabled="setCheckExcercise.isCheck" -->
    <!-- v-model="dataSource.answerContent"  -->
    <!-- :value="dataSource.answerContent"  -->
  </div>
</template>

<script>
import mixinsQuestionPreview from "./../../_store/mixinsQuestionPreview";
import { APP_CONFIG } from "@/utils/constants";
import { STORE_KEY } from "./../../_store/constants";
import { mapState, mapActions } from "vuex";

export default {
  name: "FillInputImg",
  mixins: [mixinsQuestionPreview],
  data() {
    return {
      focusId: null,
      urlQuestionImg: APP_CONFIG.urlQuestionImg,
      txtSelection: "",
    };
  },
  computed: {
    ...mapState(STORE_KEY, ["valVituralKeyboard"]),
    ...mapState("common", ["setCheckExcercise"]),
  },
  methods: {
    ...mapActions(STORE_KEY, ["setVituralKeyVal", "acSetTxtInputSelected"]),

    handleFocus(evt, info = {}) {
      this.handleMouseSelection(evt);
      // document.getSelection && console.log('Selected: ', document.getSelection())
      let halfWindowHeight = window.innerHeight / 2;
      let offsetTopElm =
        this.$refs[
          `fill_img_${info.questionId}_${info.location}`
        ].getBoundingClientRect().top;
      let offsetLeftElm =
        this.$refs[
          `fill_img_${info.questionId}_${info.location}`
        ].getBoundingClientRect().left;

      let spaceHeightInput =
        (offsetTopElm / window.innerHeight) * 100 > 80 ? 20 : 50; // 50 or 20 is height input

      // Obj have ref key support render value onpress vitural keyboard
      this.setVituralKeyVal({
        ...info,
        val: evt.target.value,
        isOverHaflScreen: offsetTopElm > halfWindowHeight ? true : false,
        ref: `fill_img_${info.questionId}_${info.location}`,
        top: offsetTopElm + spaceHeightInput,
        left: offsetLeftElm / 2, // /2 is box center
      });
    },

    handleBlur(evt) {
      this.setVituralKeyVal({
        ...this.valVituralKeyboard,
        val: evt.target.value,
      });
    },

    handleMouseSelection(evt) {
      let value = evt.target.value;
      this.txtSelection = evt.target.value.slice(
        evt.target.selectionStart,
        evt.target.selectionEnd
      );
      if (this.txtSelection) {
        let lengthTxt = value.length;
        let firstTxt = value.slice(0, evt.target.selectionStart);
        let lastTxt = value.slice(evt.target.selectionEnd, lengthTxt);
        this.acSetTxtInputSelected([firstTxt, lastTxt]);
      } else {
        this.acSetTxtInputSelected([]);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.bg--white {
  background: #fff;
}
// .css-border{
// 	border: 1px solid #ccc;
// 	border-radius: 8px;
// }
</style>

<style lang="scss" scoped>
.label-answer {
  position: absolute;
  bottom: -15px;
  right: -30px;
  width: auto !important;
  min-width: 50px;
  line-height: 50px;
  margin: 0;
}

.input-sizer {
  display: inline-grid !important;
  vertical-align: top !important;
  align-items: center !important;
  bottom: -23px;
  right: -30px;
  position: absolute;
  background-color: #fff;

  &.stacked {
    align-items: stretch !important;

    &::after,
    input,
    textarea {
      grid-area: 2 / 1;
    }
  }

  &::after,
  input,
  textarea {
    width: auto !important;
    grid-area: 1 / 2;
    resize: none !important;
    background: none !important;
    appearance: none !important;
  }

  &::after {
    content: attr(data-value) " ";
    visibility: hidden !important;
    white-space: pre-wrap !important;
  }

  &:focus-within {
    textarea:focus,
    input:focus {
      outline: none !important;
    }
  }
}

.question--fill_input_img--1 .question-body .answer input {
  position: initial !important;
}
</style>